import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Tween } from 'react-gsap';
import Section from '../Section.jsx';
import styles from './SectionImageText.module.scss';

function SectionImageText({ className, imageClassName, imageSrc, imagePosition, imageCredit, imageCreditClassName, textClassName, text, children }) {
  const imageEl = (
    <div
      className={ classnames(styles.image, imageClassName) }
      style={{ backgroundImage: `url('${process.env.PUBLIC_URL}/${imageSrc}')` }}
    >
      { children }

      {
        imageCredit && (
          <div className={ classnames(styles.credit, imageCreditClassName) }>
            { imageCredit }
          </div>
        )
      }
    </div>
  );
  const textEl = (
    <p className={ classnames(styles.text, textClassName) }>
      { text }
    </p>
  );
  return (
    <Section scrub className={ classnames(styles.container, className) }>
      {
        imagePosition === 'left' ? (
          <>
            <Tween from={{ opacity: 0, x: '-20%' }} to={{ opacity: 1, x: '0%' }}>
              { imageEl }
            </Tween>
            <Tween from={{ opacity: 0, scale: 1.25 }} to={{ opacity: 1, scale: 1 }}>
              { textEl }
            </Tween>
          </>
        ) : (
          <>
            <Tween from={{ opacity: 0, scale: 1.25 }} to={{ opacity: 1, scale: 1 }}>
              { textEl }
            </Tween>
            <Tween from={{ opacity: 0, x: '20%' }} to={{ opacity: 1, x: '0%' }}>
              { imageEl }
            </Tween>
          </>
        )
      }
    </Section>
  );
}

SectionImageText.propTypes = {
  className: PropTypes.string.isRequired,
  imageClassName: PropTypes.string.isRequired,
  imageSrc: PropTypes.string.isRequired,
  imagePosition: PropTypes.string.isRequired,
  imageCredit: PropTypes.node,
  imageCreditClassName: PropTypes.string,
  textClassName: PropTypes.string.isRequired,
  text: PropTypes.node.isRequired,
  children: PropTypes.node,
};

export default SectionImageText;
